/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TextConditionSetupParameterAssignment
 */
export interface TextConditionSetupParameterAssignment {
    /**
     * 
     * @type {string}
     * @memberof TextConditionSetupParameterAssignment
     */
    setupParameterId: string;
    /**
     * 
     * @type {string}
     * @memberof TextConditionSetupParameterAssignment
     */
    value: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextConditionSetupParameterAssignment
     */
    $type?: TextConditionSetupParameterAssignmentTypeEnum;
}


/**
 * @export
 */
export const TextConditionSetupParameterAssignmentTypeEnum = {
    PtwPtw100AppZeroCoreSharedTaskItemComponentConditionValueAssignmentsTextConditionSetupParameterAssignmentPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.TextConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type TextConditionSetupParameterAssignmentTypeEnum = typeof TextConditionSetupParameterAssignmentTypeEnum[keyof typeof TextConditionSetupParameterAssignmentTypeEnum];



/**
 * Check if a given object implements the TextConditionSetupParameterAssignment interface.
 */
export function instanceOfTextConditionSetupParameterAssignment(value?: unknown): value is TextConditionSetupParameterAssignment {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TextConditionSetupParameterAssignmentTypeEnum)[0];
}

export function TextConditionSetupParameterAssignmentFromJSON(json: any): TextConditionSetupParameterAssignment {
    return TextConditionSetupParameterAssignmentFromJSONTyped(json, false);
}

export function TextConditionSetupParameterAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextConditionSetupParameterAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'setupParameterId': json['setupParameterId'],
        'value': json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TextConditionSetupParameterAssignmentToJSON(value?: TextConditionSetupParameterAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'setupParameterId': value['setupParameterId'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

